import React, { useRef } from 'react';
import { useMousePosition } from '../../hooks';

/**
 * Componente MouseParallax
 * Aplica movimiento parallax basado en la posición del ratón
 * 
 * @param {React.ReactNode} children - Contenido a aplicar parallax
 * @param {number} intensity - Intensidad del efecto (0.1 = sutil, 0.5 = intenso)
 */
export const MouseParallax = ({ children, intensity = 0.1 }) => {
  // Hook personalizado para obtener la posición actual del mouse
  const mousePosition = useMousePosition();

  // Referencia al elemento DOM para posibles manipulaciones futuras
  const elementRef = useRef(null);
  
  // Calcular el centro de la ventana (eje X e Y)
  const centerX = window.innerWidth / 2;
  const centerY = window.innerHeight / 2;
  
  // Calcular el desplazamiento en X e Y según la posición del mouse y la intensidad
  const offsetX = (mousePosition.x - centerX) * intensity;
  const offsetY = (mousePosition.y - centerY) * intensity;
  
  return (
    <div
      ref={elementRef} // Asigna la referencia al div
      style={{
        // Aplica la transformación parallax usando translate
        transform: `translate(${offsetX}px, ${offsetY}px)`,
        // Transición suave para el movimiento
        transition: 'transform 0.1s ease-out',
      }}
    >
      {/* Renderiza los hijos dentro del contenedor parallax */}
      {children}
    </div>
  );
};